import { z } from 'zod';
import type { UserAllowedCompanyEntry, UserAllowedCategoryEntry } from '@/types/userPermissions.types';

export const userAllowedCompanySchema = z.object({
  company_id: z.string().uuid('Μη έγκυρο ID εταιρείας')
}) satisfies z.ZodType<UserAllowedCompanyEntry>;

export const userAllowedCategorySchema = z.object({
  category_id: z.string().uuid('Μη έγκυρο ID κατηγορίας')
}) satisfies z.ZodType<UserAllowedCategoryEntry>;
